// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2J8_p","image":"style_image__18qk0"};